import { createApi, BaseQueryFn, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./dynamicBaseQuery";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: dynamicBaseQuery as BaseQueryFn<string | { url: string; method: string; body?: any }, unknown, FetchBaseQueryError>,
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, LoginRequestBody>({
      query: (body) => ({
        url: "/login/cleint-login",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;